import { OrganizationKeyName } from "../../../model/Organization";

export const UPSERT_SHOP_SUCCESS = "SHOP:UPSERT_SHOP_SUCCESS";

export const upsertShopSuccessAction = (
  organization: OrganizationKeyName,
  id?: string
) => ({
  type: UPSERT_SHOP_SUCCESS as typeof UPSERT_SHOP_SUCCESS,
  organization,
  id,
});

export type UpsertShopSuccess = ReturnType<typeof upsertShopSuccessAction>;
